"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightPlaceholderDropHandler = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../model");
var widgets_1 = require("../../../widgets");
var sizing_1 = require("../../../_staging/layout/sizing");
function useInsightPlaceholderDropHandler(sectionIndex, itemIndex) {
    var dispatch = model_1.useDashboardDispatch();
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var replaceInsightOntoPlaceholder = model_1.useDashboardCommandProcessing({
        commandCreator: model_1.addSectionItem,
        errorEvent: "GDC.DASH/EVT.COMMAND.FAILED",
        successEvent: "GDC.DASH/EVT.FLUID_LAYOUT.ITEMS_ADDED",
        onSuccess: function () {
            dispatch(model_1.uiActions.selectWidget(sdk_model_1.idRef(widgets_1.INSIGHT_PLACEHOLDER_WIDGET_ID)));
            dispatch(model_1.uiActions.setConfigurationPanelOpened(true));
        },
    }).run;
    return react_1.useCallback(function () {
        var sizeInfo = sizing_1.getInsightPlaceholderSizeInfo(settings);
        replaceInsightOntoPlaceholder(sectionIndex, itemIndex, {
            type: "IDashboardLayoutItem",
            size: {
                xl: {
                    gridHeight: sizeInfo.height.default,
                    gridWidth: sizeInfo.width.default,
                },
            },
            widget: widgets_1.newInsightPlaceholderWidget(),
        });
    }, [itemIndex, replaceInsightOntoPlaceholder, sectionIndex, settings]);
}
exports.useInsightPlaceholderDropHandler = useInsightPlaceholderDropHandler;
//# sourceMappingURL=useInsightPlaceholderDropHandler.js.map